import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Immutable, { Map, List } from 'immutable'; // eslint-disable-line

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
// import NavBar from '../../components/toolbars/NavBar';
import { OrganizationActions } from '../../actions/organization';
import OrganizationUsers from './OrganizationUsers';
import OrganizationBilling from './OrganizationBilling';
import OrganizationSubscriptions from './OrganizationSubscriptions';
import OrganizationAccounts from '../../components/OrganizationAccounts';
import FullScreenModal from '../../components/modals/FullScreenModal';
import CreateAccountButton from '../../components/buttons/CreateAccountButton';
import { currentUserSelector } from '../../reducers/users';
import NavBarNew from '../../components/toolbars/NavBarNew';

if (__CLIENT__) {
  require('../../styles/Dashboard.css');
}
class OrganizationTabs extends React.Component {
  static propTypes = {
    activeTab: PropTypes.string,
    organizationId: PropTypes.string,
  };

  tabClasses = tabName => {
    const { activeTab } = this.props;
    return classNames({
      'nav-link': true,
      active: tabName === activeTab,
    });
  };

  render() {
    const { organizationId } = this.props;

    return (
      <ul className="nav nav-pills clearfix" style={{ paddingBottom: 10 }}>
        {/*<li className="nav-item">
          <Link
            className={this.tabClasses('dashboard')}
            to={`/organizations/${organizationId}/dashboard`}
          >
            Dashboard
          </Link>
        </li>*/}
        <li className="nav-item">
          <Link
            className={this.tabClasses('users')}
            to={`/organizations/${organizationId}/users`}
          >
            Users
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={this.tabClasses('accounts')}
            to={`/organizations/${organizationId}/accounts`}
          >
            Accounts
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={this.tabClasses('billing')}
            to={`/organizations/${organizationId}/billing`}
          >
            Billing
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={this.tabClasses('subscriptions')}
            to={`/organizations/${organizationId}/subscriptions`}
          >
            Subscriptions
          </Link>
        </li>
      </ul>
    );
  }
}

export class MainDashboard extends React.Component {
  render() {
    return <div>Stuff we don't have (summary)</div>;
  }
}

export class Users extends React.Component {
  render() {
    return <OrganizationUsers {...this.props} />;
  }
}

export class Accounts extends React.Component {
  render() {
    return <OrganizationAccounts {...this.props} />;
  }
}

export class Billing extends React.Component {
  render() {
    return <OrganizationBilling {...this.props} />;
  }
}

export class Subscriptions extends React.Component {
  render() {
    return <OrganizationSubscriptions {...this.props} />;
  }
}

const organizationSelector = (state, props) => {
  return state.organizations.getIn(['organizations', props.organizationId]);
};

const DashboardSelector = immutableCreatorSelector(
  [organizationSelector, currentUserSelector],
  (organization, currentUser) => {
    return {
      organization,
      currentUser,
    };
  },
);

@connect(DashboardSelector)
class Dashboard extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    activeTab: PropTypes.string,
    organizationId: PropTypes.string,
    organization: PropTypes.instanceOf(Map),
    currentUser: PropTypes.instanceOf(Map),
  };

  componentDidMount() {
    const { dispatch, organizationId, organization } = this.props;

    if (!organization) {
      dispatch(OrganizationActions.getOrganization(organizationId));
    }
  }

  render() {
    const {
      children,
      activeTab,
      organizationId,
      organization,
      currentUser,
    } = this.props;

    if (!organization) {
      return <div />;
    }

    const organizationName = organization.get('name');

    return (
      <div>
        <NavBarNew />
        <div className="main-container" style={{ marginLeft: 50 }}>
          <div className="col-xs-12 p-3 clearfix">
            <h2 className="float-sm-left mb-0">
              {organizationName} Organization Dashboard
            </h2>
            <div className="button-group float-sm-left ml-3">
              <CreateAccountButton
                organizationId={organizationId}
                currentUser={currentUser}
              />
            </div>
          </div>
          <div className="col-xs-12 p-3">
            <OrganizationTabs
              activeTab={activeTab}
              organizationId={organizationId}
            />
            {children}
          </div>
        </div>
      </div>
    );
  }
}

@connect(_state => ({}))
class DashboardContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    location: PropTypes.object,
    params: PropTypes.object,
  };

  componentDidMount() {
    const {
      dispatch,
      params: { organizationId },
    } = this.props;

    dispatch(OrganizationActions.setOrganizationId(organizationId));
  }

  render() {
    const {
      dispatch,
      children,
      location: { pathname },
      params: { organizationId },
    } = this.props;

    const activeTab = pathname.substr(pathname.lastIndexOf('/') + 1);

    return (
      <Dashboard
        dispatch={dispatch}
        activeTab={activeTab}
        organizationId={organizationId}
      >
        {children}
        <FullScreenModal />
      </Dashboard>
    );
  }
}

export { DashboardContainer as OrganizationDashboard };



// WEBPACK FOOTER //
// ./src/views/Organization/Organization.js